export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--6-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--6-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./KardexPage.vue?vue&type=style&index=0&id=cef59c8a&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/KardexPage.vue?vue&type=style&index=0&id=cef59c8a&prod&scoped=true&lang=css&
// module id = 615
// module chunks = 10